var persistent_site_menu_observer = null;

/**
 * Offer slider
 */
var persistent_site_menu = function() {

  function getParameterByName( name ){
    name = name.replace(/[\[]/,"\\\[").replace(/[\]]/,"\\\]");
    var regexS = "[\\?&]"+name+"=([^&#]*)";
    var regex = new RegExp( regexS );
    var results = regex.exec( window.location.href );
    if( results == null )
      return "";
    else
      return decodeURIComponent(results[1].replace(/\+/g, " "));
  }

  function maybeAddPersistentParameters() {

    // ignore if visitor is a bot
    if (navigator.userAgent.match(/bot|googlebot|Siteimprove|crawler|spider|robot|crawling/i)) {
      return;
    }

    // get query parameter from_site value
    var passed_slug = getParameterByName('from_site');
    var passed_language = getParameterByName('from_site_lang');
    var site_slug = document.body.getAttribute('data-site-slug');
    var site_language = document.body.getAttribute('data-site-language');

    if (!site_slug && !passed_slug) {
      return;
    }

    // if passed_slug is not empty, use it
    if (passed_slug) {
      site_slug = passed_slug;
    }

    if (passed_language) {
      site_language = passed_language;
    }

    var blacklisted_from_sites = [
      'asiakkaana-kuntoutus-ja-terapiapalveluissa',
    ];

    if (blacklisted_from_sites.indexOf(site_slug) !== -1) {
      return;
    }

    var selectors = [
      '.site-content .card.employee',
      '.site-content .card.office',
      '.employee-card__link',
      '.office-card__link',
      '.site-content a[href*="/asiantuntijat/"]',
      '.site-content a[href*="/toimipaikat/"]',
      '.site-navigation a[href*="/asiakkaana-kuntoutus-ja-terapiapalveluissa/"]',
      '.wp-block-button a[href*="/asiakkaana-kuntoutus-ja-terapiapalveluissa/"]',
      '.highlight-block a[href*="/asiakkaana-kuntoutus-ja-terapiapalveluissa/"]',
      '.highlight-block a[href*="/asiakkaana-kuntoutus-ja-terapiapalveluissa/"]',
      '.articles-item a[href*="/asiakkaana-kuntoutus-ja-terapiapalveluissa/"]',
      '.site-navigation a[href*="/asiantuntijat/"]',
      '.site-navigation a[href*="/toimipaikat/"]',
      '.js-event-card a',
      '.js-offices-nearby-generic-cta',
      '.js-offices-nearby-cta a',
      '.js-material-card a',
    ];

    // add argumen to links
    var els = document.querySelectorAll(selectors.join(','));
    for (var i = 0; i < els.length; i++) {
      var el = els[i];
      var href = el.getAttribute('href');
      var has_from_site = href && href.indexOf('from_site=') !== -1;
      var has_from_site_language = href && href.indexOf('from_site_lang=') !== -1;
      var parameters = [];

      if (!href || (has_from_site && (!site_language || has_from_site_language))) {
        continue;
      }

      if (!has_from_site) {
        parameters.push('from_site=' + encodeURIComponent(site_slug));
      }

      if (site_language && !has_from_site_language) {
        parameters.push('from_site_lang=' + encodeURIComponent(site_language));
      }

      if (!parameters.length) {
        continue;
      }

      // extract anchor element from href
      var anchor = '';
      if (href.indexOf('#') !== -1) {
        anchor = href.substring(href.indexOf('#'));
        href = href.substring(0, href.indexOf('#'));
      }

      // check if there are any parameters
      if (href.indexOf('?') === -1) {
        href += '?';
      } else {
        href += '&';
      }
      href += parameters.join('&');

      // re-add anchor
      if (anchor.length > 0) {
        href += anchor;
      }

      el.setAttribute('href', href);
    }

    // add flag to body class
    document.body.classList.add('has-persistent-site-menu');

  }

  maybeAddPersistentParameters();

  if (window.MutationObserver && !persistent_site_menu_observer && document.body) {
    persistent_site_menu_observer = new window.MutationObserver(function() {
      maybeAddPersistentParameters();
    });
    persistent_site_menu_observer.observe(document.body, {
      childList: true,
      subtree: true,
    });
  }

  window.addEventListener('cor_ajax_complete', maybeAddPersistentParameters);
  window.addEventListener('GrowthstackReplacementDone', maybeAddPersistentParameters);
  document.addEventListener('CoronariaOfficesNearbyDone', maybeAddPersistentParameters);

};

document.addEventListener('DOMContentLoaded', function(event) {
  persistent_site_menu();
});

/**
 * A/B test
 *
 * Run with:
// var event = new Event('CORPersistentSiteMenu');
// window.dispatchEvent(event);
window.addEventListener('CORPersistentSiteMenu', function(event) {
  persistent_site_menu();
});
 */

